import { EErrorCode } from "../enums/EErrorCode";
import { CHttpUtil } from "../utils/CHttpUtil";
import * as Constants from "../constants";
import moment from "moment";
import { IAppointment } from "../interfaces/IAppointment";

const TAG = "CApiRestful";

export class CApiRestful {
  public static async getBranchList() {
    var resp;

    try {
      //const wsClientName = Constants.REST_CLIENT_NAME;
      //const password = Constants.REST_PASSWORD;

      const corporateUrl = (window as any).app.config.CorporateUrl;
      const endPointUrlGetBranchList = (window as any).app.config
        .EndPointUrlGetBranchList;

      const jsonResp = await CHttpUtil.get(
        corporateUrl + endPointUrlGetBranchList,
      );
      if (jsonResp.errorCode != EErrorCode.NONE) {
        throw {
          message: jsonResp.errorMessage,
        };
      }

      resp = jsonResp.data;
    } catch (err: any) {
      throw err;
    }

    return resp;
  }

  public static async getServiceList() {
    var resp;

    try {
      //const wsClientName = Constants.REST_CLIENT_NAME;
      //const password = Constants.REST_PASSWORD;

      const corporateUrl = (window as any).app.config.CorporateUrl;
      const endPointUrlGetServiceList = (window as any).app.config
        .EndPointUrlGetServiceList;

      const jsonResp = await CHttpUtil.get(
        corporateUrl + endPointUrlGetServiceList,
      );
      if (jsonResp.errorCode != EErrorCode.NONE) {
        throw {
          message: jsonResp.errorMessage,
        };
      }

      resp = jsonResp.data;
    } catch (err: any) {
      throw err;
    }

    return resp;
  }

  public static async getApptFreeSlotList(
    branchCode: string,
    serviceNo: number,
    apptDate: string
  ) {
    var resp;

    try {
      /*const jsonBody = {
        GetApptFreeSlotListReq: {
          WsAuth: {
            WsClientName: Constants.REST_CLIENT_NAME,
            Password: Constants.REST_PASSWORD,
          },
          Appt: {
            ApptDate: apptDate,
            Service: {
              IndService: {
                ServiceNo: serviceNo,
              },
            },
            IndBranch: {
              BranchCode: branchCode,
            },
          },
        },
      };*/

	  const jsonBody = {
	  	branchCode: branchCode,
		serviceNo: serviceNo,
		apptDate: apptDate
	  };

      const corporateUrl = (window as any).app.config.CorporateUrl;
      const endPointUrlGetApptFreeSlotList = (window as any).app.config
        .EndPointUrlGetApptFreeSlotList;

      const jsonResp = await CHttpUtil.post(
        corporateUrl + endPointUrlGetApptFreeSlotList,
        jsonBody
      );
      if (jsonResp.errorCode != EErrorCode.NONE) {
        throw {
          message: jsonResp.errorMessage,
        };
      }

      resp = jsonResp.data;
    } catch (err: any) {
      throw err;
    }

    return resp;
  }

  public static async makeAppt(
    branchCode: string,
    serviceNo: number,
    apptDate: string,
    syncId: string,
    mobilePhoneNumber: string,
    firstName: string,
    lastName: string,
    emailAddr: string,
    appointmentType: string,
    icNumber?: string,
    passportNumber?: string,
    otherId?: string,
    name2?: string,
    signature?: string,
  ) {
    var resp;

    try {
	
		const jsonBody = {
	  		branchCode: branchCode,
			serviceNo: serviceNo,
			apptDate: apptDate,
			syncId: syncId,
		    mobilePhoneNumber: mobilePhoneNumber,
		    firstName: firstName,
		    lastName: lastName,
		    emailAddr: emailAddr,
			appointmentType: appointmentType,
		    icNumber: icNumber,
		    passportNumber: passportNumber,
		    otherId: otherId,
		    name2: name2,
			signature: signature
	  	};

      /*const jsonBody = {
        UpdateApptListReq: {
          WsAuth: {
            WsClientName: Constants.REST_CLIENT_NAME,
            Password: Constants.REST_PASSWORD,
          },
          MntApptList: {
            MntAppt: [
              {
                MntMode: "A",
                Appt: {
                  CustInfo: {
                    AppointmentType: appointmentType,
                    Name: firstName + " " + lastName,
                    EmailAddr: emailAddr,
                    PolicyNumber: otherId,
                    Remarks: name2,
                  },
                  EmailToSend: "true",
                  IndBranch: {
                    BranchCode: branchCode,
                  },
                  Service: {
                    IndService: {
                      ServiceNo: serviceNo,
                    },
                  },
                  Cust: {
                    MobilePhoneNumber: mobilePhoneNumber,
                    IndCust: {
                      FirstName: firstName,
                      LastName: lastName,
                      EmailAddr: emailAddr,
                      IcNumber: icNumber,
                      PassportNumber: passportNumber,
                      OtherId: otherId,
                      Name2: name2,
                      SyncId: syncId,
                    },
                  },
                  ApptDate: apptDate,
                  ApptSlot: {
                    StartTime: apptDate,
                  },
                  Signature: signature,
                },
              },
            ],
          },
        },
      };*/

      const corporateUrl = (window as any).app.config.CorporateUrl;
      const endPointUrlMakeAppt = (window as any).app.config
        .EndPointUrlMakeAppt;

      const jsonResp = await CHttpUtil.post(
        corporateUrl + endPointUrlMakeAppt,
        jsonBody
      );
      if (jsonResp.errorCode != EErrorCode.NONE) {
        throw {
          message: jsonResp.errorMessage,
        };
      }

      resp = jsonResp.data;
    } catch (err: any) {
      throw err;
    }

    return resp;
  }

  public static async getApptList(
    syncId: string,
    mobilePhoneNumber: string,
    signature: string,
  ) {
    var resp;

    try {
      const previousAppointmentDay = (window as any).app.config.PreviousAppointmentDay;
      const upcomingAppointmentDay = (window as any).app.config.UpcomingAppointmentDay;

      const startDateStr = moment().add(previousAppointmentDay * -1, "days").format("YYYY-MM-DD");
      const endDateStr = moment().add(upcomingAppointmentDay, "days").format("YYYY-MM-DD");

      /*const jsonBody = {
        GetApptListReq: {
          WsAuth: {
            WsClientName: Constants.REST_CLIENT_NAME,
            Password: Constants.REST_PASSWORD,
          },
          ApptCriteria: {
            Appt: {
              Cust: {
                IndCust: {
                  SyncId: syncId,
                },
                MobilePhoneNumber: mobilePhoneNumber,
              },
              Signature: signature
            },
            DateRange: {
              StartDate: startDateStr + "T00:00:00",
              EndDate: endDateStr + "T00:00:00",
            },
          }
        }
      };*/

	  const jsonBody = {
	  	syncId: syncId,
		mobilePhoneNumber: mobilePhoneNumber,
		startDate: startDateStr + "T00:00:00",
		endDate: endDateStr + "T00:00:00",
		signature: signature
	  };

      const corporateUrl = (window as any).app.config.CorporateUrl;
      const endPointUrlGetApptList = (window as any).app.config
        .EndPointUrlGetApptList;

      const jsonResp = await CHttpUtil.post(
        corporateUrl + endPointUrlGetApptList,
        jsonBody
      );
      if (jsonResp.errorCode != EErrorCode.NONE) {
        throw {
          message: jsonResp.errorMessage,
        };
      }

      resp = jsonResp.data;
    } catch (err: any) {
      throw err;
    }

    return resp;
  }

  public static async cancelAppt(
    branchCode: string,
    apptCode: string,
    syncId: string,
  ) {
    var resp;

    try {
      /*const jsonBody = {
        CancelApptReq: {
          WsAuth: {
            WsClientName: Constants.REST_CLIENT_NAME,
            Password: Constants.REST_PASSWORD,
          },
          MntApptList: {
            MntAppt: [ 
              {
                ApptCriteria: {
                  Appt: {
                    IndBranch: {
                      BranchCode: branchCode
                    },
                    EmailToSend: "true",
                    IndAppt: {
                      ApptCode: apptCode,
                    },
                    Cust: {
                      IndCust: {
                        SyncId: syncId,
                      },
                    }
                  },
                }
              }
            ]
          }
        }
      };*/

	  const jsonBody = {
	  	branchCode: branchCode,
		apptCode: apptCode,
		syncId: syncId
	  };

      const corporateUrl = (window as any).app.config.CorporateUrl;
      const endPointUrlCancelAppt = (window as any).app.config
        .EndPointUrlCancelAppt;

      const jsonResp = await CHttpUtil.post(
        corporateUrl + endPointUrlCancelAppt,
        jsonBody
      );
      if (jsonResp.errorCode != EErrorCode.NONE) {
        throw {
          message: jsonResp.errorMessage,
        };
      }

      resp = jsonResp.data;
    } catch (err: any) {
      throw err;
    }

    return resp;
  }

  public static async changeAppt(
    syncId: string,
    mobilePhoneNumber: string,
    apptCode: string,
    serviceNo: number,
    apptDate: Date | null,
    apptTime: string,
    appointmentType: string,
    branchCode?: string,
    appt?: IAppointment,
  ) {
    var resp;

    try {
      var formattedApptDate = "";
      if (apptDate) {
        formattedApptDate = moment(apptDate).format("YYYY-MM-DD");
      }

      var formattedApptTime = "";
      if (apptTime && apptTime.length > 0) {
        formattedApptTime = moment(apptTime).format("HH:mm:ss");
      }

      /*const jsonBody = {
        ChangeApptReq: {
          WsAuth: {
            WsClientName: Constants.REST_CLIENT_NAME,
            Password: Constants.REST_PASSWORD,
          },
          Appt: {
            IndBranch: {
              BranchCode: branchCode
            },
            IndAppt: {
              ApptCode: apptCode,
            },
            EmailToSend: "true",
            Service: {
              IndService: {
                ServiceNo: serviceNo,
              }
            },
            CustInfo: {
              AppointmentType: appointmentType,
              Name: appt?.name,
              EmailAddr: appt?.emailAddr,
              PolicyNumber: appt?.policyCertificateNum,
              Remarks: appt?.remarks,
            },
            Cust: {
              IndCust: {
                SyncId: syncId,
              },
              MobilePhoneNumber: mobilePhoneNumber,
            },
            ApptSlot: {
              IndApptSlot: {
                ApptSlotId: "",
              },
              StartTime: "",
            },
            ApptDate: formattedApptDate,
            ApptTime: formattedApptTime,
          },
        }
      };*/

	  const jsonBody = {
	  	branchCode: branchCode,
		apptCode: apptCode,
		serviceNo: serviceNo,
		appointmentType: appointmentType,
		name: appt?.name,
		emailAddr: appt?.emailAddr,             
        policyNumber: appt?.policyCertificateNum,      
        remarks: appt?.remarks,      
		syncId: syncId,
		mobilePhoneNumber: mobilePhoneNumber,
		apptDate: formattedApptDate,
		apptTime: formattedApptTime
	  };
		
      const corporateUrl = (window as any).app.config.CorporateUrl;
      const endPointUrlChangeAppt = (window as any).app.config
        .EndPointUrlChangeAppt;

      const jsonResp = await CHttpUtil.post(
        corporateUrl + endPointUrlChangeAppt,
        jsonBody
      );
      if (jsonResp.errorCode != EErrorCode.NONE) {
        throw {
          message: jsonResp.errorMessage,
        };
      }

      resp = jsonResp.data;
    } catch (err: any) {
      throw err;
    }

    return resp;
  }
}
